import React, { useState } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { TextField } from "cakemail-ui-components/lib/react";
import PropTypes from "prop-types";
import { updateLocalBrand } from "assets/js/scenes/brand/actions";
import { validateEmail, validateUrl } from "utils/validators";

export const BrandString = (props) => {
	const [state, setState] = useState({
		value: props.string,
		valid: "",
		message: null,
	});

	function setInfo(value, valid = "valid", message = null) {
		if (value === props.defaultString) {
			props.updateLocalBrand(
				props.path,
				value,
				{ value: value, valid: valid },
				true
			);
		} else {
			props.updateLocalBrand(props.path, value, {
				value: value,
				valid: valid,
			});
		}

		setState({ value: value, valid: valid, message: message });
	}

	function handleChange(e) {
		const { value } = e.currentTarget;
		setInfo(value);
	}

	function handleChangeTimeout(name, value) {
		if (props.type === "email") {
			let { valid, message } = validateEmail(value);
			setInfo(value, valid, message);
		} else {
			let input = validateUrl(value, name);
			setInfo(input[name], input[`${name}_valid`], input[`${name}_message`]);
		}
	}

	return (
		<div className="brandElement-string">
			<TextField
				name={props.fieldName}
				onChange={handleChange}
				valid={state.valid}
				message={state.message}
				value={state.value}
				timeoutOptions={
					props.type === "string" ? null : { callback: handleChangeTimeout }
				}
				placeholder={props.fieldPlaceholder}
			/>
		</div>
	);
};

BrandString.propTypes = {
	string: PropTypes.string,
	defaultString: PropTypes.string,
	path: PropTypes.string,
	updateLocalBrand: PropTypes.func,
	type: PropTypes.oneOf(["string", "email", "url"]),
	fieldName: PropTypes.string,
	fieldPlaceholder: PropTypes.string,
};

BrandString.defaultProps = {
	string: "",
	type: "string",
	fieldName: "",
	fieldPlaceholder: "",
};

export default withRouter(
	connect(
		(state) => {
			return {};
		},
		(dispatch) =>
			bindActionCreators(
				{
					updateLocalBrand,
				},
				dispatch
			)
	)(BrandString)
);
